'use strict';

import { Entity } from '../Entity';
import { Ind } from '../Ind/Ind';

export class UserAlert extends Entity {
  protected alertId;
  protected alertDetails;
  protected alertDate;
  protected ind;
  protected alertStatus;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.alertId = data.alertId;
    this.alertDetails = data.alertDetails;
    this.ind = data.ind;

    if (data.alertDate) {
      const alertDate = data.alertDate.date.split(' ')[0].split('-');
      this.alertDate = alertDate[1] + '/' + alertDate[2] + '/' + alertDate[0];

      this.alertStatus = this.setAlertStatus(data.alertDate.date);
    }
  }

  public getAlertId() {
    return this.alertId;
  }

  public getAlertDetails() {
    return this.alertDetails;
  }

  public setAlertDetails(alertDetails) {
    this.alertDetails = alertDetails;
    return this;
  }

  public getAlertDate() {
    return this.alertDate;
  }

  public setAlertDate(alertDate) {
    this.alertDate = alertDate;
    return this;
  }

  public getInd() {
    return this.ind;
  }

  public setInd(ind) {
    this.ind = ind;
    return this;
  }

  public getAlertStatus() {
    return this.alertStatus;
  }

  public setAlertStatus(alertDate) {
    const aDate = new Date(alertDate.replace(' ', 'T'));
    const now = new Date();
    now.setHours(0, 0, 0, 0);

    if (aDate <= now) {
      this.alertStatus = 'past';
    } else {
      this.alertStatus = 'future';
    }

    return this.alertStatus;
  }
}
